export const STATUS_OPTIONS = [
    {
        type: "ordered",
        text: "Оформлен",
        shortText: "Оформлен",
        hint: "Заказ создан и попал в систему.",
    },
    {
        type: "confirmed",
        text: "Подтверждён оператором",
        shortText: "Подтверждён",
        hint: "Оператор проверил заказ и подтвердил его.",
    },
    {
        type: "work",
        text: "Производство",
        shortText: "Производство",
        hint: "Заказ передан в работу.",
    },
    {
        type: "shipped",
        text: "Передан в службу доставки",
        shortText: "В доставке",
        hint: "Заказ передан в доставку.",
    },
    {
        type: "delivered",
        text: "Доставлен",
        shortText: "Доставлен",
        hint: "Заказ доставлен клиенту.",
    },
];
